import { TooltipComponent } from '@components/core/tooltip.component';
import type { SelectOption } from '@utils/select.util';
import type { FC, ReactNode } from 'react';

type EffectDefinitionTooltipProps = {
  definition?: ReactNode;
  side?: 'bottom' | 'left' | 'right' | 'top';
  trigger?: ReactNode;
};

type EffectSelectOptionProps = {
  option: Pick<SelectOption, 'description' | 'label'>;
};

export const EffectDefinitionTooltip: FC<EffectDefinitionTooltipProps> = (props) => {
  const { definition, side = 'right', trigger } = props;

  if (!definition) {
    return trigger ? <>{trigger}</> : null;
  }

  return (
    <TooltipComponent
      className="text-xs whitespace-pre-wrap font-normal"
      side={side}
      trigger={trigger}
    >
      {definition}
    </TooltipComponent>
  );
};

export const EffectSelectOption: FC<EffectSelectOptionProps> = (props) => {
  const { option } = props;

  return (
    <div className="flex min-w-0 flex-col gap-0.5 py-1">
      <span className="text-sm font-medium leading-tight text-gray-900">{option.label}</span>
      {option.description && (
        <span className="whitespace-normal text-xs leading-snug text-muted-foreground">{option.description}</span>
      )}
    </div>
  );
};
